<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="dialog-title">Pré-visualização da importação</h1>
    <button mat-icon-button (click)="escolherOutroArquivo()" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">

    <!-- Descrição + observação -->
    <form [formGroup]="formCabecalho" class="cabecalho-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Descrição do inventário</mat-label>
        <input matInput formControlName="descricao" placeholder="Ex.: Inventário Coletor - Maio 2025" required />
        @if (formCabecalho.get('descricao')?.invalid && formCabecalho.get('descricao')?.touched) {
          <mat-error>Descrição obrigatória.</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Observação</mat-label>
        <textarea matInput formControlName="observacao" rows="2"></textarea>
      </mat-form-field>
    </form>

    <!-- Chips de filtro de status -->
    <div class="validation-header mb-3">
      <div class="metric-item clickable"
           [class.active-metric]="filtroStatus === 'todos'"
           (click)="filtrar('todos')">
        <span class="metric-label">todos</span>
        <strong class="metric-value">{{ totalGeral }}</strong>
      </div>
      <div class="metric-item clickable"
           [class.active-metric]="filtroStatus === 'validos'"
           (click)="filtrar('validos')">
        <span class="metric-label"><span class="dot dot-green"></span> estoque igual</span>
        <span class="metric-value-sm">{{ data.validacao.totalValidos }}</span>
      </div>
      <div class="metric-item clickable"
           [class.active-metric]="filtroStatus === 'avisos'"
           (click)="filtrar('avisos')">
        <span class="metric-label"><span class="dot dot-yellow"></span> divergente</span>
        <span class="metric-value-sm">{{ data.validacao.totalAvisos }}</span>
      </div>
      <div class="metric-item clickable"
           [class.active-metric]="filtroStatus === 'naoConferidos'"
           (click)="filtrar('naoConferidos')">
        <span class="metric-label"><span class="dot dot-blue"></span> não conferido</span>
        <span class="metric-value-sm">{{ data.validacao.totalNaoConferidos }}</span>
      </div>
      <div class="metric-item clickable"
           [class.active-metric]="filtroStatus === 'erros'"
           (click)="filtrar('erros')">
        <span class="metric-label"><span class="dot dot-red"></span> não encontrado</span>
        <span class="metric-value-sm">{{ data.validacao.totalErros }}</span>
      </div>
    </div>

    <!-- Tabela -->
    <div class="table-container">
      <table mat-table [dataSource]="itensFiltrados">

        <ng-container matColumnDef="status" sticky>
          <th mat-header-cell *matHeaderCellDef class="w-status">Situação</th>
          <td mat-cell *matCellDef="let item" class="w-status"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">
            <div class="status-dots">
              <span class="dot" [ngClass]="getDotClass(item.status)"></span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="codigoSku">
          <th mat-header-cell *matHeaderCellDef>SKU</th>
          <td mat-cell *matCellDef="let item"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">{{ item.codigoSku }}</td>
        </ng-container>

        <ng-container matColumnDef="gtinEan">
          <th mat-header-cell *matHeaderCellDef>GTIN/EAN</th>
          <td mat-cell *matCellDef="let item"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">{{ item.gtinEan }}</td>
        </ng-container>

        <ng-container matColumnDef="nomeProduto">
          <th mat-header-cell *matHeaderCellDef>Produto</th>
          <td mat-cell *matCellDef="let item"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">{{ item.nomeProduto }}</td>
        </ng-container>

        <ng-container matColumnDef="nomeLocalizacao">
          <th mat-header-cell *matHeaderCellDef>Localização</th>
          <td mat-cell *matCellDef="let item"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">{{ item.nomeLocalizacao }}</td>
        </ng-container>

        <ng-container matColumnDef="saldoSistema">
          <th mat-header-cell *matHeaderCellDef class="text-right">Saldo atual</th>
          <td mat-cell *matCellDef="let item" class="text-right"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">{{ formatarNumero(item.saldoSistema) }}</td>
        </ng-container>

        <ng-container matColumnDef="saldoContado">
          <th mat-header-cell *matHeaderCellDef class="text-right">Qtd. lida</th>
          <td mat-cell *matCellDef="let item" class="text-right"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">
            @if (podeEditarQuantidade(item)) {
              <input type="text" inputmode="decimal" class="qty-input"
                     [(ngModel)]="item.saldoContado"
                     [ngModelOptions]="{ standalone: true }"
                     [currencyMask]="quantidadeMask"
                     (ngModelChange)="onSaldoContadoChange(item)" />
            } @else {
              {{ formatarNumero(item.saldoContado) }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="ajuste">
          <th mat-header-cell *matHeaderCellDef class="text-right">Ajuste</th>
          <td mat-cell *matCellDef="let item" class="text-right" [ngClass]="ajusteClass(item.ajuste)"
              [matTooltip]="getTooltip(item)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">
            {{ formatarNumero(item.ajuste) }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasExibidas; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasExibidas" [ngClass]="getRowClass(row)"></tr>
      </table>

      @if (itensFiltrados.length === 0) {
        <div class="empty-state p-4 text-center text-muted">Nenhum item encontrado neste filtro.</div>
      }
    </div>
  </div>

  <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <div class="actions-wrapper">
      <button mat-stroked-button class="btn-secondary" (click)="escolherOutroArquivo()">
        <mat-icon class="material-symbols-outlined">refresh</mat-icon> escolher outro arquivo
      </button>
      <button mat-flat-button class="btn-primary"
              [disabled]="formCabecalho.invalid || data.validacao.totalErros > 0 || isConfirmando"
              (click)="confirmarEGravar()">
        @if (isConfirmando) {
          <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
          <span class="material-symbols-outlined">check</span> confirmar e gravar
        }
      </button>
    </div>
  </div>
</div>
